import { MappedProduct } from '@/fo/util/map-product-data';

export type MapProductGTMItemInput = Pick<
  MappedProduct,
  | 'sku'
  | 'name'
  | 'brand'
  | 'series'
  | 'volume'
  | 'basePrice'
  | 'finalPrice'
  | 'itemPrice'
  | 'quantity'
>;

export const mapProductGTMItem = (
  item: MapProductGTMItemInput,
  index: number
) => {
  return {
    item_id: item.sku || '',
    item_name: item.name || '',
    price: String(item.itemPrice ?? item.finalPrice ?? item.basePrice),
    item_brand: item.brand || null,
    item_category: item.series || null,
    variant: item.volume || null,
    position: index + 1,
    quantity: item.quantity
  };
};
